import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import { getAppUIVariantConfig } from 'Util/uiVariantSet';
import { AccessContentModal, MESSAGE_TYPE } from 'Components/AccessContentModal';
import { useConfig } from 'Context/ConfigContext';
import useMyExternalProfile from 'Routes/Classroom/Domain/useMyExternalProfile';

const NoAccessibleCourseModal = ({ isActive, onContinue }) => {
  const { Modal } = getAppUIVariantConfig();
  const history = useHistory();
  const { landingRoute = '/my-courses' } = useConfig();
  const { data } = useMyExternalProfile();
  const providerName = data?.myExternalProfile?.providerName ?? '';
  // provider name : learned from anywhere
  const messageType =
    providerName === 'learned'
      ? MESSAGE_TYPE.NO_ACCESSIBLE_COURSE_LEARNED
      : MESSAGE_TYPE.ENTER_CLASSROOM_ERROR;

  const handleGoToLandingPage = () => {
    if (typeof onContinue === 'function') return onContinue();
    return history.replace(landingRoute);
  };

  switch (Modal) {
    case 'Rounded':
    default: {
      return (
        <AccessContentModal
          messageType={messageType}
          muiProps={{ isActive }}
          onClick={handleGoToLandingPage}
        />
      );
    }
  }
};

NoAccessibleCourseModal.propTypes = {
  isActive: PropTypes.bool,
  onContinue: PropTypes.func,
};

export default NoAccessibleCourseModal;
